import { ConfigDictionary } from './models';
import { createAction } from '@reduxjs/toolkit';

export const ConfigStoreUpdate = createAction<Partial<ConfigDictionary>>('CONFIG_STORE_UPDATE');